export const isLoggedIn = state => state.isLoggedIn;
export const getAccessToken = state => state.access_token;
